module.exports = __webpack_public_path__ + "img/image_part_001.dc44afec.jpg";